module.exports = __webpack_public_path__ + "static/img/buy_stop.861efc8c.png";